module.exports = __webpack_public_path__ + "static/img/14000667.d9a662b4.png";